// =========================================
// SavInvest — Traductions FRANÇAISES (défaut)
// =========================================

const fr = {
  // Navigation
  nav: {
    dashboard: 'Tableau de bord',
    purchases: 'Achats',
    sales: 'Ventes',
    products: 'Produits',
    campaigns: 'Campagnes',
    investments: 'Investissements',
    partners: 'Partenaires',
    profile: 'Mon Profil',
    logout: 'Déconnexion',
    companies: 'Entreprises',
    cagnotte: 'Cagnotte',
  },

  // Auth
  auth: {
    login: 'Connexion',
    register: "S'inscrire",
    email: 'Email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    nom: 'Nom',
    prenom: 'Prénom',
    tel: 'Téléphone',
    role: 'Rôle',
    investor: 'Propriétaire',
    partner: 'Partenaire',
    loginTitle: 'Bienvenue sur SavInvest',
    loginSubtitle: 'Connectez-vous pour gérer vos investissements',
    registerTitle: 'Créer un compte',
    registerSubtitle: 'Rejoignez SavInvest et gérez vos finances',
    alreadyHaveAccount: 'Déjà un compte ?',
    noAccount: "Pas encore de compte ?",
    forgotPassword: 'Mot de passe oublié ?',
    step1: 'Informations personnelles',
    step2: 'Votre entreprise',
    step3: 'Confirmation',
    joinExistingCompany: 'Rejoindre une entreprise existante',
    createNewCompany: 'Créer une nouvelle entreprise',
    noCompany: 'Sans entreprise',
  },

    // Dashboard
  dashboard: {
    title: 'Tableau de bord',
    subtitle: 'Vue d\'ensemble de votre activité',
    totalSales: 'Total Ventes',
    totalPurchases: 'Total Achats',
    totalInvestments: 'Total Investissements',
    benefice: 'Bénéfice Net Global',
    revient: 'Revient (Ventes - Achats)',
    revientSub: 'Marge commerciale brute',
    diffInvestAchats: 'Solde (Investi - Achats)',
    diffInvestAchatsSub: 'Capital restant non dépensé',
    totalCampaigns: 'Campagnes',
    investors: 'Propriétaires',
    partners: 'Partenaires',
    stock: 'Produits',
    stockAlert: 'Alertes Stock',
    stockAlertTitle: 'Alertes de niveau de stock',
    stockAlertWarning: 'Certains produits nécessitent votre attention (stock faible ou épuisé).',
    stockAllGood: 'Tous les niveaux de stock sont optimaux ✓',
    evolution: 'Évolution temporelle',
    salesEvolution: 'Évolution des ventes',
    purchasesEvolution: 'Évolution des achats',
    profitLoss: 'Bénéfices & Pertes',
    filterByCampaign: 'Filtrer par campagne',
    allCampaigns: 'Toutes les campagnes',
    filterByDate: 'Période & Dates',
    dateDebut: 'Du',
    dateFin: 'Au',
    periodAll: 'Tout',
    period7d: '7 jours',
    period30d: '30 jours',
    periodMonth: 'Ce mois',
    periodYear: 'Cette année',
    resetFilters: 'Réinitialiser',
    myRevenues: 'Mes Revenus',
    myRevenuesSub: 'Ma part sur le bénéfice net',
    myShare: '% des parts',
    marginPositive: '✓ Marge Positive',
    marginNegative: '↓ Marge Négative',
    capitalAvailable: '✓ Capital Disponible',
    budgetOverrun: '⚠ Dépassement Budget',
    beneficeFormula: 'Ventes − Investissements',
    salesFormula: 'Ventes',
    purchasesFormula: 'Achats',
    investedFormula: 'Investi',
    consumed: 'consommé',
    profitFormula: 'Bénéfice',
    sharesTotal: 'Σ Parts',
    sharesBalanced: '✓ Équilibré',
    sharesAbove: 'du total',
    noShareAssigned: 'Aucune part attribuée — définissez les pourcentages dans les profils.',
    beneficeByCampaign: 'Bénéfice par Campagne — Répartition des Parts',
    sharesBreakdown: 'RÉPARTITION DES PARTS',
    stockManagement: 'Gestion des stocks',
    stockOutOf: 'produit(s) en rupture',
    stockAllAvailable: 'Tous les stocks disponibles',
    stockOutBanner: 'Rupture de stock',
    stockRefillPrompt: 'Ces produits sont épuisés, veuillez réapprovisionner.',
    stockStatusOut: 'Rupture',
    stockStatusLow: '⚠ Faible',
    stockStatusOk: 'En stock',
    myInvestmentsByCampaign: 'Mes investissements par campagne',
    colCampaign: 'Campagne',
    colAmount: 'Montant',
    colDate: 'Date',
    colShare: 'Part (%)',
    colProduct: 'Produit',
    colQty: 'Quantité',
    colSalePrice: 'Prix de vente',
    colStockValue: 'Valeur stock',
    colStatus: 'Statut',
    margin: 'Marge',
  },

  // Produits
  products: {
    title: 'Gestion des produits',
    add: 'Ajouter un produit',
    edit: 'Modifier le produit',
    libelle: 'Désignation',
    quantite: 'Quantité en stock',
    prixVente: 'Prix unitaire de vente (FCFA)',
    valeurStock: 'Valeur du stock',
    noProducts: 'Aucun produit enregistré',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
  },

  // Achats
  purchases: {
    title: 'Gestion des achats',
    add: 'Ajouter un achat',
    produit: 'Produit',
    quantite: 'Quantité',
    prixUnitaire: 'Prix unitaire d\'achat (FCFA)',
    total: 'Total (FCFA)',
    date: 'Date',
    campagne: 'Campagne associée',
    noPurchases: 'Aucun achat enregistré',
  },

  // Ventes
  sales: {
    title: 'Gestion des ventes',
    add: 'Ajouter une vente',
    client: 'Client',
    produit: 'Produit',
    quantite: 'Quantité',
    prixVente: 'Prix unitaire (FCFA)',
    total: 'Total (FCFA)',
    date: 'Date',
    campagne: 'Campagne associée',
    noSales: 'Aucune vente enregistrée',
    stockInsuffisant: 'Stock insuffisant',
  },

  // Campagnes
  campaigns: {
    title: 'Campagnes',
    add: 'Nouvelle campagne',
    libelle: 'Libellé',
    description: 'Description',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    budgetInitial: 'Budget initial (FCFA)',
    totalInvesti: 'Total investi',
    statut: 'Statut',
    active: 'Active',
    closed: 'Clôturée',
    noCampaigns: 'Aucune campagne',
  },

  // Investissements
  investments: {
    title: 'Investissements',
    add: 'Ajouter un investissement',
    campagne: 'Campagne',
    montant: 'Montant (FCFA)',
    pourcentage: 'Part (%)',
    date: 'Date',
    notes: 'Notes',
    noInvestments: 'Aucun investissement',
  },

  // Partenaires
  partners: {
    title: 'Gestion des partenaires',
    add: 'Nouveau partenaire',
    edit: 'Modifier le partenaire',
    name: 'Nom complet',
    email: 'Email',
    tel: 'Téléphone',
    password: 'Mot de passe temporaire',
    company: 'Entreprise affiliée',
    role: 'Rôle',
    noPartners: 'Aucun partenaire enregistré',
    remove: 'Retirer',
    createPartnerTitle: 'Créer un compte partenaire',
    createPartnerSubtitle: 'Ce partenaire pourra se connecter à la plateforme',
  },

  // Profil
  profile: {
    title: 'Mon Profil',
    subtitle: 'Gérez vos informations personnelles, photo et sécurité',
    personalInfo: 'Informations personnelles',
    photoAvatar: 'Photo de profil',
    changePhoto: 'Changer la photo',
    removePhoto: 'Supprimer',
    photoHint: 'Formats acceptés : JPG, PNG, WebP (max 5 Mo)',
    companyInfo: 'Mon Entreprise',
    security: 'Sécurité & Mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    passwordHint: 'Laissez vide si vous ne souhaitez pas modifier votre mot de passe',
    saveSuccess: 'Profil mis à jour avec succès ✓',
    roleInvestorBadge: '👑 Propriétaire',
    rolePartnerBadge: '🤝 Partenaire',
  },

  // Statistiques
  stats: {
    transactions: 'transactions',
    fcfa: 'FCFA',
    vs: 'vs période précédente',
    profit: 'Bénéficiaire',
    loss: 'En perte',
    stockLow: 'Stock faible',
  },

  // Actions communes
  common: {
    save: 'Enregistrer',
    saveChanges: 'Enregistrer les modifications',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    close: 'Fermer',
    confirm: 'Confirmer',
    search: 'Rechercher...',
    loading: 'Chargement...',
    noData: 'Aucune donnée disponible',
    actions: 'Actions',
    total: 'Total',
    success: 'Succès',
    error: 'Erreur',
    required: 'Champ obligatoire',
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Soumettre',
    welcome: 'Bienvenue',
    hello: 'Bonjour',
  },

  // Entreprise
  company: {
    title: 'Entreprise',
    libelle: 'Nom de l\'entreprise',
    capacite: 'Capacité',
    pays: 'Pays',
    ville: 'Ville',
    description: 'Description',
    domaine: "Domaine d'activité",
  },

  // Cagnotte / Fonds Commun
  cagnotte: {
    title: 'Mes Cagnottes',
    subtitle: 'Gérez vos fonds communs et cotisations mensuelles',
    add: 'Nouvelle Cagnotte',
    edit: 'Modifier la Cagnotte',
    libelle: 'Nom de la cagnotte',
    description: 'Description',
    objectifMensuel: 'Objectif mensuel par membre',
    devise: 'Devise',
    statut: 'Statut',
    active: 'Active',
    closed: 'Clôturée',
    noCagnottes: 'Aucune cagnotte. Créez-en une ou attendez une invitation.',
    total: 'Total collecté',
    solde: 'Solde disponible',
    depenses: 'Total dépenses',
    membres: 'Membres',
    cotisations: 'Cotisations',
    operations: 'Opérations',
    bankInfo: 'Compte Bancaire',
    mobileMoneyInfo: 'Mobile Money',
    compteBancaire: 'Numéro de compte',
    banqueNom: 'Nom de la banque',
    mobileNumero: 'Numéro Mobile Money',
    mobileType: 'Opérateur (Wave, Orange Money...)',
    mobileLien: 'Lien de paiement (URL)',
    invite: 'Inviter un membre',
    inviteEmail: 'Email à inviter',
    logCotisation: 'Saisir ma cotisation',
    logCotisationFor: 'Saisir pour un membre',
    logOperation: 'Ajouter une opération',
    cotisationMontant: 'Montant de la cotisation',
    cotisationMois: 'Mois (YYYY-MM)',
    cotisationNote: 'Note',
    operationLibelle: 'Libellé de l\'opération',
    operationMontant: 'Montant',
    operationType: 'Type',
    operationDate: 'Date',
    operationNote: 'Note',
    typeDepense: 'Dépense',
    typeRetrait: 'Retrait',
    typeRemboursement: 'Remboursement',
    typeAutre: 'Autre',
    memberSince: 'Membre depuis',
    paid: 'Payé',
    notPaid: 'Non payé',
    matrixTitle: 'Suivi des cotisations',
    adminBadge: '👑 Admin',
    inviteSuccess: 'Invitation envoyée !',
    inviteLinkCopied: 'Lien copié dans le presse-papier',
    deleteConfirm: 'Supprimer définitivement cette cagnotte ?',
    removeMemberConfirm: 'Retirer ce membre ?',
  },
};

export default fr;
